/**
 * documentextensionreducer.js
 * Created by calhosh on 10/22/2020.
 */
import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function documentExtensionReducer(state = initialstate.documentExtensions, action) {
	switch (action.type) {
		case actions.GET_ALL_DOCUMENT_EXTENSION:
			if (action.response) {
				return action.response || state;
			}
			break;
		default:
			return state;
	}
}
